import api from '../axios/axiosConfig';

export const getChargeId = async (cpcodeId: string, connectorId: number) => {
    try {
        const response = await api.get(`/GetChargerId/${cpcodeId}-${connectorId}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar o charge Id', error);
        throw error;
    }
};
